import { Controller } from '@hotwired/stimulus';
import copyAndNotify from '@frontend/utils/copy-and-notify';

export default class extends Controller {
  static values = {
    url: String,
    successMessage: {
      type: String,
      default: 'Link kopiert.',
    },
  };

  connect() {
    this.element.addEventListener('click', this.handleClick.bind(this));
    this.element.addEventListener('onkeydown', this.handleClick.bind(this));
  }

  async handleClick(event) {
    event.preventDefault();

    const url = this.hasUrlValue ? this.urlValue : this.element.href;
    copyAndNotify(url, this.successMessageValue);
  }
}
